import React from "react";
import { SectionUnlockingSwitch } from "features/AdminPanel/modules/SectionUnlockingSwitch/SectionUnlockingSwitch";
import { EMI_DURATION_OPTIONS } from "../../../../../ManageOfferings/modules/OfferingPaymentOptions/constants/OfferingPaymentOptions.constants";
import { useCommonToggleSectionSwitch } from "./utils/hooks/useCommonToggleSectionSwitch";
import { ExlyDropdown } from "common/form";

export const CommonToggleSectionSwitch = ({ subSectionKey = "" }) => {
  const {
    isEMI,
    isToggleOn,
    showDurations,
    disableSwitch,
    selectedTenure,
    setSelectedTenure,
    handleToggle,
  } = useCommonToggleSectionSwitch({ subSectionKey });

  const showEmiDuration = isEMI && showDurations;

  if (!isEMI) {
    return (
      <SectionUnlockingSwitch
        value={isToggleOn}
        onChange={handleToggle}
        disabled={disableSwitch}
      />
    );
  }

  return (
    <div className="tw-flex tw-flex-col tw-items-end md:tw-flex-row md:tw-items-center tw-gap-4">
      <div className="tw-shrink-0">
        <SectionUnlockingSwitch
          value={isToggleOn}
          onChange={handleToggle}
          disabled={disableSwitch}
        />
      </div>

      {showEmiDuration && (
        <div className="tw-w-30 max-md:tw-w-36">
          <ExlyDropdown
            input={{
              value: selectedTenure ?? [],
              onChange: setSelectedTenure,
              name: "emi_tenure",
            }}
            meta={{}}
            options={EMI_DURATION_OPTIONS}
            multiple
            checked
            showChips
            placeholder="Select EMI duration"
            helperText={
              !selectedTenure || selectedTenure.length === 0
                ? "Please select at least one EMI duration"
                : null
            }
            inputBaseRootClassName="tw-text-xs"
            selectClassName="tw-text-xs"
            menuItemClassName="tw-text-xs"
            SelectDisplayProps={{
              style: {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
        </div>
      )}
    </div>
  );
};
